"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HardIcon = HardIcon;
var _SvgIcon2 = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function HardIcon(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon2.default, _extends({
    viewBox: "0 0 37 32"
  }, props), /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask-hard-icon"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    fill: "white",
    height: "100%",
    id: "bg",
    width: "100%",
    x: "0",
    y: "0"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 16C11.1046 16 12 15.1046 12 14C12 12.8954 11.1046 12 10 12C8.89543 12 8 12.8954 8 14C8 15.1046 8.89543 16 10 16Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22 16C23.1046 16 24 15.1046 24 14C24 12.8954 23.1046 12 22 12C20.8954 12 20 12.8954 20 14C20 15.1046 20.8954 16 22 16Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16 25C17.6569 25 19 23.6569 19 22C19 20.3431 17.6569 19 16 19C14.3431 19 13 20.3431 13 22C13 23.6569 14.3431 25 16 25Z",
    fill: "black"
  })), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M28.609 6.149C28.203 7.087 28 7.895 28 8.585C28 10.252 28.777 11.737 29.985 12.681C27.334 16.169 26 18.703 26 20.459C26 22.586 27.284 24.414 29.11 25.173C26.218 29.301 21.425 32 16 32C7.163 32 0 24.837 0 16C0 7.163 7.163 0 16 0C21.121 0 25.68 2.406 28.609 6.149Z",
    fill: "currentColor",
    fillRule: "evenodd",
    mask: "url(#mask-hard-icon)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30 8.58498C30 10.335 31.379 11.745 33.068 11.745C34.757 11.745 36.135 10.335 36.135 8.58498C36.135 7.48498 35.117 5.46698 33.068 2.66498C31.018 5.46698 30 7.48498 30 8.58498ZM28 20.459C28 22.17 29.348 23.549 31 23.549C32.652 23.549 34 22.17 34 20.459C34 19.384 33.004 17.409 31 14.666C28.996 17.408 28 19.384 28 20.459Z",
    fill: "currentColor",
    opacity: "0.8"
  }));
}